import { render } from "./ItemView.vue?vue&type=template&id=4139081c&scoped=true"
import script from "./ItemView.vue?vue&type=script&lang=js"
export * from "./ItemView.vue?vue&type=script&lang=js"

import "./ItemView.vue?vue&type=style&index=0&id=4139081c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4139081c"]])

export default __exports__